// @flow weak

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../redux/modules/actions";
import Site from "./Site";

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        enterHome: actions.enterHome,
        leaveHome: actions.leaveHome,

        fetchEarningGraphDataIfNeeded: actions.fetchEarningGraphDataIfNeeded,
        fetchTeamMatesDataIfNeeded: actions.fetchTeamMatesDataIfNeeded
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Site);



// WEBPACK FOOTER //
// ./src/app/views/site/index.js